import React, { FunctionComponent } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import parse from "date-fns/parse";
import isValid from "date-fns/isValid";
import { PersonalTaxFormNavigation } from "./formNavigation/PersonalTaxFormNavigation";
import { PersonalTaxForm } from "./types";
import "./personalTaxPage.css";
import { CompanyBanner } from "./CompanyBanner";
import { PersonaliaForm } from "./personaliaForm/PersonaliaForm";
import { BurgerlijkeStaatForm } from "./burgerlijkeStaatForm/BurgerlijkeStaatForm";
import { AangiftecodesForm } from "./aangiftecodesForm/AangiftecodesForm";
import { GezinslastenForm } from "./gezinslastenForm/GezinslastenForm";
import { Trans } from "@lingui/macro";
import { TaxCalculationResult } from "./taxCalculationResult/TaxCalculationResult";
import { FormikPersist } from "components/FormikPersist";
import { useWhiteLabelSetting } from "components/WhiteLabelProvider";
import { ChangeBurgerlijkeStaatWarning } from "./ChangeBurgerlijkeStaatWarning";

const validDate = Yup.string().test("Date", (<Trans>Geen geldige datum (dd/mm/jjjj)</Trans>) as any, (value) => {
  if (!value || value === "__/__/____") {
    return true;
  }
  const date = parse(value, "dd/MM/yyyy", new Date());
  return isValid(date);
});

const schema = Yup.object().shape({
  c3004: validDate,
  c1552: validDate,
  c3005: validDate,
  c2552: validDate,
});

export const PersonalTaxPage: FunctionComponent = () => {
  const [currentForm, setCurrentForm] = React.useState<PersonalTaxForm>("personalia");
  const companyName = useWhiteLabelSetting("name") as string;

  const handleReset = React.useCallback(() => {
    setCurrentForm("personalia");
  }, []);

  return (
    <Formik
      initialValues={{ c1002: true, c3003: true }}
      onSubmit={console.log}
      validationSchema={schema}
      validateOnBlur
      validateOnChange={false}
      onReset={handleReset}
    >
      <Form>
        <FormikPersist name={companyName}>
          <ChangeBurgerlijkeStaatWarning />
          <div className="tax-page">
            <PersonalTaxFormNavigation onChange={setCurrentForm} activeForm={currentForm} />
            <div className="bannercontainerwrapper">
              {currentForm !== "resultaat" && <CompanyBanner />}
              {(() => {
                switch (currentForm) {
                  case "personalia":
                    return <PersonaliaForm />;
                  case "burgerlijksStaat":
                    return <BurgerlijkeStaatForm />;
                  case "aangiftecodes":
                    return <AangiftecodesForm />;
                  case "gezinslasten":
                    return <GezinslastenForm />;
                  case "resultaat":
                    return <TaxCalculationResult />;
                }
              })()}
            </div>
          </div>
        </FormikPersist>
      </Form>
    </Formik>
  );
};

PersonalTaxPage.displayName = "PersonalTaxPage";
